import React from "react";
import { useState, useEffect, Fragment } from "react";
import AuthService from "../../services/auth.service";
import api from "../../services/api";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import AdminTopBar from "../../components/Admin/AdminTopBar";
import AdminCalfList from "../../components/Admin/AdminCalfList";
import AdminUserDetail from "../../components/Admin/AdminUserDetails";
import { Dialog, Transition } from "@headlessui/react";

function Admin() {
  const navigate = useNavigate();
  const currentUser = AuthService.getCurrentUser();
  if (!currentUser.roles.includes("ROLE_ADMIN")) navigate("/");
  let { userId } = useParams();
  const [user, setUser] = useState({});
  const [search, setSearch] = useState("");
  const [listCalfs, setListCalfs] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isDisplay, setDisplay] = useState(false);

  const getUser = () => {
    api
      .get("/user/" + userId)
      .then((response) => {
        const data = response.data;
        setUser(data);
      })
      .catch((error) => {
        console.error("There was an error getting the users!", error);
      });
  };

  const getCalfs = (userId) => {
    api
      .get("/calfs/user/" + userId)
      .then((response) => {
        const data = response.data;
        setListCalfs(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };
  const refreshCalfs = () => {
    getCalfs(userId);
  };
  const handleClose = () => {
    setDisplay(!isDisplay);
  };

  useEffect(() => {
    //Runs only on the first render
    getUser();
    getCalfs(userId);
  }, []);
  return (
    <div className="flex flex-col text-sm">
      <AdminTopBar></AdminTopBar>
      <div className="flex flex-col self-center md:w-[1200px]">
        <div className="mb-3 flex w-fit items-center justify-center rounded-lg bg-stone-200/60 px-3 py-1 text-sm">
          <Link to={"/admin/"}>
            <span className="text-sm font-medium text-stone-500">
              Tous les utilisateurs
            </span>
          </Link>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="mr-1 h-4 w-4 text-stone-300"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8.25 4.5l7.5 7.5-7.5 7.5"
            />
          </svg>
          <Link to={"/admin/user/" + user.id}>
            <span className="text-sm font-semibold text-stone-500">
              {user.name}
            </span>
          </Link>
        </div>
        <div className="mb-3 flex justify-between">
          <div>
            <span className="text-2xl font-bold">
              Tableau de bord de {user.name}
            </span>
          </div>

          <div className="flex">
            <input
              className="mr-3 w-full rounded-md border border-stone-300 px-3 py-2 text-sm md:w-64 md:self-end"
              placeholder="Chercher"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            ></input>
            <button
              onClick={() => navigate("/nouveau")}
              className="flex rounded-md border border-amber-500 bg-amber-400 px-3 py-2 text-sm text-white shadow transition-all duration-100 hover:shadow-inner"
            >
              Ajouter un veau
            </button>
          </div>
        </div>
        <div className="mb-6 w-full border-b border-stone-200"></div>
        <div className="flex">
          <div className="pr-3 md:w-1/3">
            <AdminUserDetail user={user}></AdminUserDetail>
          </div>
          <div className="pl-3 md:w-2/3">
            <AdminCalfList
              search={search}
              listCalfs={listCalfs}
              isLoading={isLoading}
            ></AdminCalfList>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Admin;
